import React from 'react'
import { useState, useEffect } from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Clients = () => {
  const [api, setApi] = useState<any>(null);
  const [current, setCurrent] = useState(0);

  const clients = [
    { name: "Biocomposites", logo: "/biocomposites.webp" },
    { name: "Conquip", logo: "/conquip.webp" },
    { name: "Cyncly", logo: "/cyncly.webp" },
    { name: "Interflora", logo: "/interflora.webp" },
    { name: "Loadsure", logo: "/loadsure.webp" },
    { name: "Maxis-GBN", logo: "/maxis.webp" },
    { name: "Octopus Investments", logo: "/octopus.webp" },
    { name: "Protyre", logo: "/protyre.webp" },
  ];

  useEffect(() => {
    if (!api) return;

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });

    // Auto-play functionality
    const interval = setInterval(() => {
      if (api.canScrollNext()) {
        api.scrollNext();
      } else {
        api.scrollTo(0);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [api]);

  const scrollTo = (index: number) => {
    api?.scrollTo(index);
  };

  return (
    <section id="clients" className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="max-w-6xl mx-auto text-center animate-on-scroll">
          <div className="mb-12">
            <h2 className="mb-6">Clients we've worked with</h2>
            <p className="text-xl text-text-secondary max-w-3xl mx-auto">
              Trusted by leading companies to deliver reliable analytics and tracking solutions.
            </p>
          </div>

          <div className="relative">
            <Carousel
              setApi={setApi}
              className="w-full"
              opts={{
                align: "start",
                loop: true,
              }}
            >
              <CarouselContent className="-ml-2 md:-ml-4">
                {clients.map((client, index) => (
                  <CarouselItem key={index} className="pl-2 md:pl-4 basis-1/2 md:basis-1/3 lg:basis-1/4">
                    <div className="group relative h-32 md:h-40 bg-gray-50 rounded-xl p-6 flex items-center justify-center hover:bg-primary/5 transition-all duration-300 border border-gray-200 hover:border-primary/20">
                      <img
                        src={client.logo}
                        alt={`${client.name} logo`}
                        className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                      />
                      <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/5 transition-all duration-300 rounded-xl"></div>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              
              {/* Navigation arrows - hidden on mobile */}
              <div className="hidden md:block">
                <CarouselPrevious className="absolute -left-16 top-1/2 -translate-y-1/2 bg-white border-2 border-primary/20 hover:border-primary/40 hover:bg-primary/5 transition-all duration-300">
                  <ChevronLeft className="h-6 w-6 text-primary" />
                </CarouselPrevious>
                <CarouselNext className="absolute -right-16 top-1/2 -translate-y-1/2 bg-white border-2 border-primary/20 hover:border-primary/40 hover:bg-primary/5 transition-all duration-300">
                  <ChevronRight className="h-6 w-6 text-primary" />
                </CarouselNext>
              </div>
            </Carousel>

            {/* Bullet navigation */}
            <div className="flex justify-center mt-8 space-x-2">
              {clients.map((_, index) => (
                <Button
                  key={index}
                  variant={current === index ? "default" : "outline"}
                  size="sm"
                  className={`w-3 h-3 rounded-full p-0 ${
                    current === index 
                      ? "bg-primary border-primary" 
                      : "bg-gray-300 border-gray-300 hover:bg-primary/20"
                  }`}
                  onClick={() => scrollTo(index)}
                >
                  <span className="sr-only">Go to slide {index + 1}</span>
                </Button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients; 